import { http, HttpResponse } from 'msw';
import { API, BASE_URL_V3 } from '../../../src/common/constants';
import type { Suggestion, SuggestionListResponse } from '../../../src/store/facade/facadeApiV3';

const URL = `${BASE_URL_V3}${API.endpoints.locationSearch}`;

export default http.post(URL, () => {
    const data: SuggestionListResponse = {
        suggestions: [autosuggestAddressData1, autosuggestAddressData2, autosuggestAddressData3],
    };

    return HttpResponse.json(data);
});

export const autosuggestAddressData1: Suggestion = {
    suggestionId: 'here:pds:place:276u281z-da9f60bd0ba14ba7a1fbfb6afe13b2c9',
    name: 'Deutsches Museum',
    address: {
        name: 'Deutsches Museum',
        street: 'Museumsinsel',
        number: '1',
        city: 'München',
        postalCode: '80538',
        countryCode: 'DEU',
    },
    coordinate: {
        latitude: 48.13138,
        longitude: 11.58561,
    },
    distance: 820,
};

export const autosuggestAddressData2: Suggestion = {
    suggestionId: 'here:pds:place:276u281z-2a7c37d9c78c46338fc225146a9ec8c2',
    name: 'Frauenkirche (Der Münchner Dom)',
    address: {
        name: 'Frauenkirche',
        street: 'Frauenplatz',
        number: '12',
        city: 'München',
        postalCode: '80331',
        countryCode: 'DEU',
    },
    coordinate: {
        latitude: 48.13885,
        longitude: 11.57457,
    },
    distance: 349,
};

export const autosuggestAddressData3: Suggestion = {
    suggestionId: 'here:pds:place:276u281z-0cca1141a5de439498888b76e79a80af',
    name: 'Deutsches Theater',
    address: {
        name: 'Deutsches Theater',
        street: 'Schwanthalerstraße',
        number: '15',
        city: 'München',
        postalCode: '80336',
        countryCode: 'DEU',
    },
    coordinate: {
        latitude: 48.13723,
        longitude: 11.56232,
    },
    distance: 1134,
};
